import { useAtomValue } from 'jotai';

import { activeAndReviewBillsAtom } from '../../bills/state/BillsAtoms';
import { BillCreationType } from '../../bills/types/Bill';
import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import useGetMembershipIncomes from '../../member-profile/hooks/useGetMembershipIncomes';
import useGetProfileDataCompleteness from '../../member-profile/hooks/useGetProfileDataCompleteness';
import { useOnboardingCompleteness } from './useOnboardingCompleteness';

export const usePreMoneyMapCompleteness = () => {
    const user = useAuthedUser();
    const hasViewedLinkMoreAccounts =
        user.memberJourneyLog?.viewedLinkMoreAccounts;
    const activeAndReviewBills = useAtomValue(activeAndReviewBillsAtom);

    const {
        isIncomeComplete: isMagicNumbersIncomeComplete,
        isBillsComplete,
        isLoadingOnboardingCompleteness: isLoadingOnboardingProfileCompleteness,
    } = useOnboardingCompleteness();

    const { data: membershipIncomes, isLoading: isLoadingMembershipIncomes } =
        useGetMembershipIncomes({});

    const isLegacyIncomeComplete =
        !isLoadingMembershipIncomes && (membershipIncomes ?? []).length > 0;
    const isIncomeComplete =
        isMagicNumbersIncomeComplete || isLegacyIncomeComplete;

    const {
        isLoading: isLoadingProfileDataCompleteness,
        isKidsDataComplete,
        isTaxDataComplete,
        isInsuranceDataComplete,
        isEmploymentStatusComplete,
    } = useGetProfileDataCompleteness();

    const isFinancialProfileComplete =
        isEmploymentStatusComplete &&
        isIncomeComplete &&
        isTaxDataComplete &&
        isInsuranceDataComplete &&
        isKidsDataComplete;

    const isPreMoneyMapComplete =
        isBillsComplete &&
        isFinancialProfileComplete &&
        hasViewedLinkMoreAccounts;

    const isLoading =
        isLoadingOnboardingProfileCompleteness ||
        isLoadingProfileDataCompleteness ||
        isLoadingMembershipIncomes;

    const hasActiveBill =
        activeAndReviewBills.filter(
            (bill) => bill.creationType !== BillCreationType.MONEY_MAPPER,
        ).length > 0;

    return {
        isLoading,
        isBillsComplete: hasActiveBill,
        isFinancialProfileComplete,
        hasViewedLinkMoreAccounts,
        isPreMoneyMapComplete,
        isEmploymentStatusComplete,
        isTaxDataComplete,
        isInsuranceDataComplete,
        isKidsDataComplete,
        isIncomeComplete,
    };
};
